// extracted by mini-css-extract-plugin
module.exports = {"root":"categories-module__root--H_RSz","sub-wrapper":"categories-module__sub-wrapper--1fciD","sub-sub-wrapper":"categories-module__sub-sub-wrapper--29EnX"};